import * as actions from '../actions/notifications';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import {getArrayQueryParameter} from "../helpers/functions";

export function requestNotificationTypes(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_NOTIFICATION_TYPES)
        .map(action => ({
            url: BASE_URL + 'api/Notifications/Notifications/Events',
            category: 'requestNotificationTypes',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    const httpResponse$ = sources.HTTP
        .select('requestNotificationTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getNotificationTypesSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestNotificationTypesFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestNotificationTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getNotificationTypesFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function getAllNotifications(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_ALL_NOTIFICATIONS )
		.map(action => ({
			url: BASE_URL + 'api/Notifications/Notifications?limit=' + action.payload.limit +
			'&offset=' + action.payload.offset +
			'&shallow=' + action.payload.shallow +
				(
					getArrayQueryParameter(action.payload.selectedCaseTypes, 'selectedCaseTypes')?
						`&${getArrayQueryParameter(action.payload.selectedCaseTypes, 'selectedCaseTypes')}`
						:
						''
				) +
				(
					getArrayQueryParameter(action.payload.selectedStatuses, 'selectedStatuses')?
						`&${getArrayQueryParameter(action.payload.selectedStatuses, 'selectedStatuses')}`
						:
						''
				) +
				(
					getArrayQueryParameter(action.payload.selectedUpdateFormQuestions, 'selectedUpdateQuestions')?
						`&${getArrayQueryParameter(action.payload.selectedUpdateFormQuestions, 'selectedUpdateQuestions')}`
						:
						''
				) +
				(
					getArrayQueryParameter(action.payload.selectedNotificationTypes, 'selectedNotificationTypes')?
						`&${getArrayQueryParameter(action.payload.selectedNotificationTypes, 'selectedNotificationTypes')}`
						:
						''
				),
			category: 'getAllNotifications',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getAllNotifications')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetAllNotifications(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badGetNotifications(sources) {
	let httpResponse$ = sources.HTTP
		.select('getAllNotifications')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestGetAllNotifications(response));

	return {
		ACTION: httpResponse$
	};
}

export function patchNotification(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_PATCH_NOTIFICATION)
		.map(action => ({
			url: BASE_URL + 'api/Notifications/Notifications/' + action.payload.key,
			category: 'patchNotification',
			method: 'PATCH',
			send: {
				id: action.payload.key,
				viewed: action.payload.value,
				applicationId: action.payload.applicationId
			},
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('patchNotification')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receivePatchNotification(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadResponsePatchApplication(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchNotification')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestPatchNotification(response));

	return {
		ACTION: httpResponse$
	};
}

//Notifications Indicator

export function getAllNotificationsIndicator(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => (action.type === ActionTypes.REQUEST_GET_NOTIFICATIONS_INDICATOR) || ( action.type === ActionTypes.RECEIVE_GET_ALL_NOTIFICATIONS) || ( action.type === ActionTypes.RECEIVE_PATCH_NOTIFICATION))
		.map(action => ({
			url: BASE_URL + 'api/Notifications/Notifications/UnseenNumber',
			category: 'getAllNotificationsIndicator',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getAllNotificationsIndicator')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveNotificationsIndicator(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetAllNotificationsIndicator(sources) {
	let httpResponse$ = sources.HTTP
		.select('getAllNotificationsIndicator')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveFailureNotificationsIndicator(response));

	return {
		ACTION: httpResponse$
	};
}


